export default {
  loading: false,
  listLoading: false,
  StateList: [],
  CityList: []
}
